import { render } from "./EmotionManagement.vue?vue&type=template&id=65409034&scoped=true"
import script from "./EmotionManagement.vue?vue&type=script&lang=js"
export * from "./EmotionManagement.vue?vue&type=script&lang=js"

import "./EmotionManagement.vue?vue&type=style&index=0&id=65409034&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65409034"]])

export default __exports__